import { render } from "./NominasView.vue?vue&type=template&id=28af4f71"
import script from "./NominasView.vue?vue&type=script&lang=js"
export * from "./NominasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__